<template>
    <div class="desktop-promo-module" ref="promoModule">
      <component :is="asyncComponent" v-if="asyncComponent" :moduleId="24"/>
    </div>
  </template>
  
  <script>
  import { defineAsyncComponent } from 'vue';
  
  export default {
    data() {
      return {
        asyncComponent: null,
      };
    },
    mounted() {

		const observer = new IntersectionObserver((entries) => {
			if (entries[0].isIntersecting) {
				import('webmd-ia-module/src/Component.vue').then((module) => {
					this.asyncComponent = defineAsyncComponent(() => Promise.resolve(module));
					observer.unobserve(entries[0].target);
				});
			}
		}, { rootMargin: '0px 0px 800px 0px' });

		if (this.$refs.promoModule) {
			observer.observe(this.$refs.promoModule);
        }
        
    },
  };
  </script>
  
  